import { postRequest } from '~/shared/utils';

export async function qualifyAbandonedBasket(apiUrl: string) {
    const request = postRequest<void>(apiUrl);

    const response = await request();

    return response;
}
